"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.imageMimeTypes = exports.iconMaps = exports.defaultVideoIcon = exports.defaultPlaceholderIcon = exports.defaultIcon = void 0;
exports.defaultIcon = "https://drapcode-static.s3.amazonaws.com/img/google-docs.png";
exports.defaultPlaceholderIcon = "https://drapcode-static.s3.amazonaws.com/img/placeholder-img.png";
exports.defaultVideoIcon = "https://drapcode-static.s3.amazonaws.com/img/video.png";
exports.iconMaps = {
  // Images
  "image/png": exports.defaultPlaceholderIcon,
  "image/jpeg": exports.defaultPlaceholderIcon,
  "image/gif": exports.defaultPlaceholderIcon,
  "image/heif": exports.defaultPlaceholderIcon,
  "image/webp": exports.defaultPlaceholderIcon,
  "image/heic": exports.defaultPlaceholderIcon,
  // Archives
  "application/zip": "https://drapcode-static.s3.amazonaws.com/img/zip.png",
  // Excel
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "https://drapcode-static.s3.amazonaws.com/img/excel.png",
  "application/vnd.ms-excel": "https://drapcode-static.s3.amazonaws.com/img/excel.png",
  // PDF
  "application/pdf": "https://drapcode-static.s3.amazonaws.com/img/pdf-file.png",
  // CSV
  "text/csv": "https://drapcode-static.s3.amazonaws.com/img/csv.png",
  // DOC
  "application/msword": exports.defaultIcon,
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": exports.defaultIcon,
  // Text
  "text/plain": "https://drapcode-static.s3.amazonaws.com/img/txt.png",
  // RTF
  "application/rtf": "https://drapcode-static.s3.amazonaws.com/img/rtf-file-symbol.png",
  // HTML
  "text/html": "https://drapcode-static.s3.amazonaws.com/img/html.png",
  // Audio
  "audio/mpeg": "https://drapcode-static.s3.amazonaws.com/img/placeholder-audio.png",
  // Video
  "video/mpeg": exports.defaultVideoIcon,
  "video/x-flv": exports.defaultVideoIcon,
  "video/x-msvideo": exports.defaultVideoIcon,
  // PowerPoint
  "application/vnd.ms-powerpoint": "https://drapcode-static.s3.amazonaws.com/img/powerpoint.png",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation": "https://drapcode-static.s3.amazonaws.com/img/powerpoint.png"
};
exports.imageMimeTypes = ["image/png", "image/jpeg", "image/webp", "image/heif", "image/heic"];